<template>
  <div class="items-chip">
    <v-chip v-for="(item, index) in itemsToShow" :key="index">
      {{ item[textKey] }}
    </v-chip>
    <span v-if="moreItems.length">
      <v-chip @click="dialog = true">+ {{ moreItems.length - limit - 1 }} </v-chip>
      <dialog-list-items v-model="dialog" :dialog-title="title" :items-to-show="moreItems" />
    </span>
  </div>
</template>

<script>
import DialogListItems from '@/components/DialogListItems.vue'

export default {
  components: { DialogListItems },
  props: {
    title: String,
    limit: {
      default: 7,
      type: Number,
    },
    items: {
      default: () => [],
      type: Array,
    },
    textKey: {
      default: 'name',
      type: String,
    },
  },
  data: () => ({
    dialog: false,
    itemsToShow: [],
    moreItems: [],
  }),
  mounted() {
    this.setChipsToShow(this.items)
  },
  methods: {
    setChipsToShow(array) {
      const { limit, textKey } = this
      if (array.length > limit) {
        this.itemsToShow = array.slice(0, limit - 1)
        this.moreItems = textKey === 'name' ? array : array.map((item) => ({ name: item[textKey] }))
      } else this.itemsToShow = array
    },
  },
}
</script>
<style lang="scss">
.items-chip {
  margin: -5px;
  > .v-chip {
    margin: 5px;
  }
}
</style>
